export const yesOrNoOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];
export const employmentTypeOptions = [
  { value: "full-time", label: "Full-time" },
  { value: "part-time", label: "Part-time" },
];
export const optionsCategories = [
  { value: "Student", label: "Student" },
  { value: "Ex-Student", label: "Ex-Student" },
];
export const optionsTypes = [
  { value: "F1", label: "F1" },
  { value: "Non-F1", label: "Non-F1" },
];
export const inactiveReasonsOptions = [
  { value: "", label: "Not Defined" },
  { value: "Canceled", label: "Canceled" },
  { value: "Terminated", label: "Terminated" },
];
export const inactivateReasonsDescriptions = [
  { reason: "Canceled", value: "Offer withdrawn", label: "Offer withdrawn" },
  {
    reason: "Canceled",
    value: "Record created in error",
    label: "Record created in error",
  },
  {
    reason: "Canceled",
    value: "Student arrived under different SEVIS ID",
    label: "Student arrived under different SEVIS ID",
  },
  {
    reason: "Canceled",
    value: "Student not attending",
    label: "Student not attending",
  },
  {
    reason: "Canceled",
    value: "Student registered under different SEVIS ID",
    label: "Student registered under different SEVIS ID",
  },
  {
    reason: "Canceled",
    value: "Visa issued for different SEVIS ID",
    label: "Visa issued for different SEVIS ID",
  },
  {
    reason: "Terminated",
    value: "Absent from country for five months",
    label: "Absent from country for five months",
  },
  {
    reason: "Terminated",
    value: "Authorized drop below full course time exceeded",
    label: "Authorized drop below full course time exceeded",
  },
  {
    reason: "Terminated",
    value: "Authorized early withdrawal",
    label: "Authorized early withdrawal",
  },
  {
    reason: "Terminated",
    value: "Change of status approved",
    label: "Change of status approved",
  },
  {
    reason: "Terminated",
    value: "Change of status denied",
    label: "Change of status denied",
  },
  {
    reason: "Terminated",
    value: "Change of status withdrawn",
    label: "Change of status withdrawn",
  },
  { reason: "Terminated", value: "Death", label: "Death" },
  {
    reason: "Terminated",
    value: "Exceeded unemployment time",
    label: "Exceeded unemployment time",
  },
  { reason: "Terminated", value: "Expulsion", label: "Expulsion" },
  {
    reason: "Terminated",
    value: "Failure to enroll",
    label: "Failure to enroll",
  },
  {
    reason: "Terminated",
    value: "Failure to report while on OPT",
    label: "Failure to report while on OPT",
  },
  {
    reason: "Terminated",
    value: "No show - manual termination",
    label: "No show - manual termination",
  },
  {
    reason: "Terminated",
    value: "Otherwise failing to maintain status",
    label: "Otherwise failing to maintain status",
  },
  { reason: "Terminated", value: "Suspension", label: "Suspension" },
  {
    reason: "Terminated",
    value: "Transfer student no show",
    label: "Transfer student no show",
  },
  {
    reason: "Terminated",
    value: "Unauthorized drop below full course",
    label: "Unauthorized drop below full course",
  },
  {
    reason: "Terminated",
    value: "Unauthorized employment",
    label: "Unauthorized employment",
  },
  {
    reason: "Terminated",
    value: "Unauthorized withdrawal",
    label: "Unauthorized withdrawal",
  },
  {
    reason: "Terminated",
    value: "Violation of change of status requirements",
    label: "Violation of change of status requirements",
  },
];
export const appliedAtOptions = [
  { value: "Tuition", label: "Tuition" },
  { value: "Registration", label: "Registration" },
  { value: "Tuition & Registration", label: "Tuition & Registration" },
  { value: "Settlement", label: "Settlement" },
];
export const optionsStatus = [
  { value: "In Class", label: "In Class" },
  { value: "School Waiting List", label: "School Waiting List" },
  { value: "Waiting", label: "Waiting" },
  { value: "Inactive", label: "Inactive" },
];
export const optionsCategory = [
  { value: "Student", label: "Student" },
  { value: "Ex-student", label: "Ex-student" },
];
export const optionsSubStatus = [
  { value: 1, label: "Initial Visa", type_id: 1 },
  { value: 2, label: "Change of Status", type_id: 1 },
  { value: 3, label: "Reinstatement", type_id: 1 },
  { value: 4, label: "Transfer", type_id: 1 },
  { value: 5, label: "Private", type_id: 2 },
  { value: 6, label: "Regular", type_id: 2 },
];
export const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Not Specified", label: "Not Specified" },
];
export const maritalStatusOptions = [
  { value: "Single", label: "Single" },
  { value: "Married", label: "Married" },
  { value: "Widowed", label: "Widowed" },
  { value: "Divorced", label: "Divorced" },
  { value: "Separated", label: "Separated" },
];
export const relationshipTypeOptions = [
  { value: "Parents", label: "Parents" },
  { value: "Grand Parents", label: "Grand Parents" },
  { value: "Brother or Sister", label: "Brother/Sister" },
  { value: "Friend", label: "Friend" },
  { value: "Husband or Wife", label: "Husband/Wife" },
  { value: "Other", label: "Other" },
];
export const dependentRelationshipTypeOptions = [
  { value: "Husband/Wife", label: "Husband/Wife" },
  { value: "Son/Daughter", label: "Son/Daughter" },
];
export const sponsorRelationshipTypeOptions = [
  { value: "Parents", label: "Parents" },
  { value: "Family", label: "Family" },
  { value: "Student Loan", label: "Student Loan" },
  {
    value: "Government Scholarship or Loan",
    label: "Government Scholarship or Loan",
  },
  { value: "Other", label: "Other" },
];
export const scheduleOptions = [
  {
    value: "4 days - Morning - 08:30 to 01:00",
    label: "4 days - Morning - 08:30 to 01:00",
  },
  {
    value: "4 days - Evening - 06:00 to 10:30",
    label: "4 days - Evening - 06:00 to 10:30",
  },
  {
    value: "2 days - Full Time (Wed - Thu) - 08:30 to 18:00",
    label: "2 days - Full Time (Wed - Thu) - 08:30 to 18:00",
  },
  {
    value: "2 days - Full Time (Mon - Tue) - 08:30 to 18:00",
    label: "2 days - Full Time (Mon - Tue) - 08:30 to 18:00",
  },
  {
    value: "2 days - Full Time (Fri - Sat) - 08:30 to 18:00",
    label: "2 days - Full Time (Fri - Sat) - 08:30 to 18:00",
  },
];
export const dept1TypeOptions = [
  { value: "Wholly Dependent", label: "Wholly Dependent" },
  { value: "Partially Dependent", label: "Partially Dependent" },
];
export const addressOptions = [
  { value: "Address in USA", label: "Address in USA" },
  { value: "Address in Home Country", label: "Address in Home Country" },
];
export const discountOptions = [
  { value: true, label: "Percent %" },
  { value: false, label: "Value $" },
];
export const discountTypesOptions = [
  { value: "Admission", label: "Admission" },
  { value: "Financial", label: "Financial" },
];
export const subStatusOptions = [
  {
    value: "Pending",
    label: "Pending",
  },
  {
    value: "Partial Paid",
    label: "Partial Paid",
  },
  {
    value: "Refunded",
    label: "Refunded",
  },
  {
    value: "Paid",
    label: "Paid",
  },
  {
    value: "Cancelled",
    label: "Cancelled",
  },
  {
    value: "Late",
    label: "Late",
  },
  {
    value: "Renegociated",
    label: "Renegociated",
  },
];

export const parametersOptions = [
  {
    department: "Commercial",
    value: "placement-test-url",
    label: "Placement Test URL",
  },
];

export const preArrivalsStatusOptions = [
  { value: "Processing", label: "Processing" },
  { value: "Denied", label: "Denied" },
  { value: "Approved", label: "Approved" },
  { value: "Gave Up", label: "Gave Up" },
];
export const invoiceTypesOptions = [
  {
    value: "Invoice",
    label: "Invoice",
  },
  {
    value: "Credit Note",
    label: "Credit Note",
  },
];
export const invoiceTypeDetailsOptions = [
  {
    value: "Tuition fee",
    label: "Tuition fee",
    type: "Invoice",
  },
  {
    value: "Registration fee",
    label: "Registration fee",
    type: "Invoice",
  },
  {
    value: "Others",
    label: "Others",
    type: "Invoice",
  },
  {
    value: "Other",
    label: "Other",
    type: "Credit Note",
  },
];
export const receivableStatusesOptions = [
  {
    value: "Pending",
    label: "Pending",
  },
  {
    value: "Paid",
    label: "Paid",
  },
  {
    value: "Partial Paid",
    label: "Partial Paid",
  },
  {
    value: "Refunded",
    label: "Refunded",
  },
  {
    value: "Renegociated",
    label: "Renegociated",
  },
  {
    value: "Overdue",
    label: "Overdue",
  },
  {
    value: "Compensated",
    label: "Compensated",
  },
  {
    value: "Awaiting_Consolidation",
    label: "Awaiting Consolidation",
  },
  {
    value: "Consolidated",
    label: "Consolidated",
  },
];
export const typeOfPaymentOptions = [
  {
    value: "Inbounds & Outbounds",
    label: "Inbounds & Outbounds",
  },
  {
    value: "Inbounds Only",
    label: "Inbounds Only",
  },
  {
    value: "Outbounds Only",
    label: "Outbounds Only",
  },
];
export const paymentPlatformOptions = [
  {
    value: "",
    label: "Select...",
  },
  {
    value: "Gravity - Online",
    label: "Gravity - Online",
  },
  {
    value: "Gravity - POS",
    label: "Gravity - POS",
  },
  {
    value: "Parcelow",
    label: "Parcelow",
  },
  {
    value: "Zelle",
    label: "Zelle",
  },
];
export const employeeTypeOptions = [
  { value: "Staff", label: "Staff" },
  { value: "Faculty", label: "Faculty" },
];
export const employeeSubtypeOptions = [
  { value: "Pay Roll", label: "Pay Roll" },
  { value: "Contract", label: "Contract" },
];
export const wageTypeOptions = [
  { value: "Hourly", label: "Hourly" },
  { value: "Salary", label: "Salary" },
];
export const classroomStatusOptions = [
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
];
export const surveyQuestionTypeOptions = [
  {
    value: "Text Area",
    label: "Text Area",
    has_options: false,
    options_edittable: false,
    defaultOptions: [],
  },
  {
    value: "Rating",
    label: "Rating",
    has_options: true,
    options_edittable: false,
    defaultOptions: [
      {
        id: null,
        option_description: "1=Completely dissatisfied",
        option_value: "1",
      },
      { id: null, option_description: "2=Dissatisfied", option_value: "2" },
      {
        id: null,
        option_description: "3=Somewhat satisfied",
        option_value: "3",
      },
      { id: null, option_description: "4=Satisfied", option_value: "4" },
      {
        id: null,
        option_description: "5=Completely satisfied",
        option_value: "5",
      },
    ],
  },
  {
    value: "Pick Many",
    label: "Pick Many",
    has_options: true,
    options_edittable: true,
    defaultOptions: [],
  },
  {
    value: "Pick One",
    label: "Pick One",
    has_options: true,
    options_edittable: true,
    defaultOptions: [],
  },
  {
    value: "Yes or No",
    label: "Yes or No",
    has_options: true,
    options_edittable: false,
    defaultOptions: [
      {
        id: null,
        option_description: "Yes",
        option_value: "Yes",
      },
      {
        id: null,
        option_description: "No",
        option_value: "No",
      },
    ],
  },
];

export const studentgroupStatusOptions = [
  { value: "In Formation", label: "In Formation" },
  { value: "Ongoing", label: "Ongoing" },
];
export const messageTypeOptions = [
  { value: "Alert", label: "Alert" },
  { value: "Notification", label: "Notification" },
  { value: "Reminder", label: "Reminder" },
  { value: "Information", label: "Information" },
  { value: "Question", label: "Question" },
  { value: "Other", label: "Other" },
];
export const messageMethodOptions = [{ value: "Email", label: "Email" }];
export const messageToStudentsOptions = [
  {
    value: "All students in filial",
    label: "All students in filial",
  },
  {
    value: "Selected students in filial",
    label: "Selected students in filial",
  },
];
export const typeOptions = [
  { value: "Administrative", label: "Administrative" },
  { value: "Academic", label: "Academic" },
];
export const dateTypeOptions = [
  { value: "Break", label: "Break" },
  { value: "Holiday", label: "Holiday" },
];

export const agentTypeOptions = [
  { value: "Internal", label: "Internal" },
  { value: "External", label: "External" },
];

export const monthsOptions = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const optionsContactForm = [
  { value: "Email", label: "Email" },
  { value: "WhatsApp", label: "WhatsApp" },
  { value: "U.S. Phone", label: "U.S. Phone" },
  { value: "Home Country Phone", label: "Home Country Phone" },
];

export const studentTypeOfDocuments = [
  {
    label: "All Documents",
    value: "all_documents",
  },
  {
    label: "Student Documents",
    value: "student_documents",
  },
  {
    label: "Enrollment Documents",
    value: "enrollment_documents",
  },
  {
    label: "Financial Documents",
    value: "financial_documents",
  },
  {
    label: "Other Documents",
    value: "other_documents",
  },
];

export const agentVisionOptions = [
  {
    label: "Restrict",
    value: "Restrict",
  },
  {
    label: "Global",
    value: "Global",
  },
];

export const periodOptions = [
  { value: "Morning", label: "Morning" },
  { value: "Afternoon", label: "Afternoon" },
  { value: "Evening", label: "Evening" },
  { value: "Full Time", label: "Full Time" },
];
